<div *ngIf="showGoTopArrow" class="go-top-arrow cursor-pointer" (click)="goToTopOfPage()">
  <app-icon glyph name="go-top-arrow"></app-icon>
</div>

<div class="sticky-header w-100 bg-dark-blue d-flex justify-content-between align-items-center">
  <div class="text-white text-size-20 ml-3 d-none d-md-block">LEARN TO FLY COURSE</div>
  <div *ngIf="!isLearnToFlyCoursePaid()"
       class="d-flex justify-content-md-start justify-content-between align-items-center top-bar">
    <div class="row pl-2 py-0 m-0">
      <app-icon *ngIf="!colorSchemeService.isDarkMode()" glyph name="lock-orange-rounded"></app-icon>
      <app-icon *ngIf="colorSchemeService.isDarkMode()" glyph name="lock-white-orange-rounded"></app-icon>
      <span class="text-white text-size-14 mx-2 align-items-center d-flex">
              Lifetime Access
            </span>
    </div>
    <div class="row pr-2 py-0 m-0">
      <span class="text-white text-size-20 d-flex align-items-center mr-2">{{ course?.price }}</span>
      @if (course?.inCoursePurchaseEnabled) {
        <a href="/demo/course/PRIVATE/welcome" class="btn btn-locked btn-round">Purchase Course</a>
      } @else {
        <a
          href="https://www.sportys.com/learn-to-fly-course-private-pilot-test-prep-online-app-and-tv.html?utm_source=onlinecoursedemo&utm_medium=referral&utm_campaign=PTdemobutton"
          target="_blank" class="btn btn-locked btn-round">Purchase Course</a>
      }
    </div>
  </div>
  <div *ngIf="isLearnToFlyCoursePaid()" class="pr-2">
    <button class="btn btn-primary btn-round study-btn px-3 text-size-12 py-2" (click)="goToTestPrep()">
      Open Course
    </button>
  </div>
</div>

<div class="content pb-0 px-0">
  <div class="content">
    <div class="header-background row px-5 mx-0">
      <div class="col-lg-6 col-md-11 offset-md-1 col-12 text-white">
        <div class="row pt-4 mt-2 d-flex justify-content-md-start justify-content-center">
          <span class="text-size-18 font-weight-light">Welcome to Sporty's</span>
        </div>
        <div class="justify-content-md-start justify-content-center row pt-2">
                    <span class="text-size-38 mt-1 d-flex text-md-left text-center">LEARN TO FLY
                        COURSE</span>
        </div>
        <div class="row header-text">
                    <span class="d-none d-md-block text-size-18 font-weight-light mt-1 mt-md-4">Ace your
                        FAA written
                        test,
                        save money during flight training, and become
                        a better pilot with Sporty's Learn To Fly Course.</span>
          <span class="d-block d-md-none text-size-16 font-weight-light text-center mt-1 mt-md-4">Ace your FAA
                        written test, save money during flight training, and become
                        a better pilot with Sporty's Learn To Fly Course.</span>
        </div>
        <div class="row pb-5 d-flex justify-content-md-start justify-content-center">
          <a class="btn btn-primary btn-round mt-2 mt-md-4 cursor-pointer py-2"
             href="https://www.sportys.com/learn-to-fly-course-private-pilot-test-prep-online-app-and-tv.html?utm_source=onlinecoursedemo&utm_medium=referral&utm_campaign=PTdemobutton"
             target="_blank">
            About This Course
            <app-icon glyph name="info-white" class="ml-2"></app-icon>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="body-content pl-md-4">
    <div class="row pl-3 pl-lg-0">
      <div class="pl-lg-3 ml-3 pl-0 ml-0">
        <div class="text-dark text-size-20 font-weight-600">FREE RESOURCES TO GET STARTED</div>
      </div>
    </div>

    <div class="d-flex free-resources justify-content-center row col-12 p-0 m-0 mt-3 pb-2">
      <div class="free-resource-item px-lg-2 px-0 pt-3 pt-lg-0">
        <div
          class="free-resources-plate plate plate-white px-2 pt-3 pb-0 pb-md-5 mb-5 mb-md-0 border-bottom-left-radius-modal border-bottom-right-radius-modal border-top-left-radius-modal border-top-right-radius-modal h-100">
          <div class="d-flex justify-content-center align-items-center plate-header">
            <span class="text-dark font-weight-500 text-size-20 ml-2">FAA Handbooks</span>
          </div>
          <hr class="w-100 my-2 color-secondary">
          <div class="d-flex justify-content-between px-0 w-100 h-75">
            <div class="free-resource-item-child">
              <a
                href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary/resource/AIRPLANE_FLYING_HANDBOOK"
                target="_blank" class="text-decoration-none">
                <img
                  class="free-resource free-resource-image  border-top-left-radius-modal border-top-right-radius-modal"
                  [ngStyle]="{'background-image': 'url(https://dl.videos.sportys.com/onlinecourse/images/docthumbs/LTF_discovery/AFH_cover.jpg)'}"
                  alt="">
                <div class="free-resource-footer text-truncate-3">Airplane Flying Handbook</div>
              </a>
            </div>
            <div class="free-resource-item-child">
              <a href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary/resource/PHAK"
                 target="_blank" class="text-decoration-none">
                <img
                  class="free-resource free-resource-image border-top-left-radius-modal border-top-right-radius-modal"
                  [ngStyle]="{'background-image': 'url(https://dl.videos.sportys.com/onlinecourse/images/docthumbs/LTF_discovery/PHAK_cover.jpg)'}"
                  alt="">
                <div class="free-resource-footer text-truncate-3">Pilot's Handbook of Aeronautical
                  Knowledge
                </div>
              </a>
            </div>
            <a class="free-resource-item-child"
               href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary">
              <div
                class="free-resource free-resource-image view-all-faa-image border-top-left-radius-modal border-top-right-radius-modal">
                <a href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary"
                   target="_blank" class="btn btn-primary btn-round view-all-btn">View All
                </a>
              </div>
              <div class="free-resource-footer text-truncate-3"
                   [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(217, 233, 249,0.1), rgba(255,255,255,255))'}">
                <div class="faded-text">
                  Aviation Weather
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="free-resource-item px-lg-2 px-0 pt-3 pt-lg-0">
        <div
          class="free-resources-plate plate plate-white px-2 pt-3 pb-0 pb-md-5 mb-5 mb-md-0 border-bottom-left-radius-modal border-bottom-right-radius-modal border-top-left-radius-modal border-top-right-radius-modal h-100">
          <div class="d-flex justify-content-center align-items-center plate-header">
            <span class="text-dark font-weight-500 text-size-20 ml-2">FAR/AIM</span>
          </div>
          <hr class="w-100 my-2 color-secondary">
          <div class="d-flex justify-content-betweenpx-0 w-100 h-75">
            <a target="_blank" href="https://courses.sportys.com/training/portal/course/PRIVATE/far"
               class="free-resource-item-child">
              <img class="free-resource free-resource-image border-top-left-radius-modal border-top-right-radius-modal"
                   [ngStyle]="{'background-image': 'url(https://dl.videos.sportys.com/onlinecourse/images/docthumbs/LTF_discovery/FAR_cover.jpg)'}"
                   alt="">
              <div class="free-resource-footer text-truncate-3">Federal Aviation Regulations</div>
            </a>
            <a target="_blank"
               href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary/resource/AERONAUTICAL_INFORMATION_MANUAL_PDF"
               class="free-resource-item-child">
              <img class="free-resource free-resource-image border-top-left-radius-modal border-top-right-radius-modal"
                   [ngStyle]="{'background-image': 'url(https://dl.videos.sportys.com/onlinecourse/images/docthumbs/LTF_discovery/AIM_cover.jpg)'}"
                   alt="">
              <div class="free-resource-footer text-truncate-3">Aeronautical Information Manual (AIM)
              </div>
            </a>
            <a target="_blank" href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary"
               class="free-resource-item-child">
              <div
                class="free-resource free-resource-image view-all-far-image border-top-left-radius-modal border-top-right-radius-modal">
                <a href="https://courses.sportys.com/training/portal/course/PRIVATE/faalibrary"
                   target="_blank" class="btn btn-primary btn-round view-all-btn">View All
                </a>
              </div>
              <div class="free-resource-footer text-truncate-3"
                   [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(217, 233, 249,0.1), rgba(255,255,255,255))'}">
                <div class="faded-text">
                  Pilot/Controller Glossary
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="free-resource-item px-lg-2 px-0 pt-3 pt-lg-0">
        <div
          class="free-resources-plate plate plate-white px-2 pt-3 pb-2 border-bottom-left-radius-modal border-bottom-right-radius-modal border-top-left-radius-modal border-top-right-radius-modal h-100">
          <div class="d-flex justify-content-center align-items-center plate-header">
            <span class="text-dark font-weight-500 text-size-20 ml-2">FAA Test Preparation</span>
          </div>
          <hr class="w-100 my-2 color-secondary">
          <div class="d-flex justify-content-between px-0 w-100 h-75">
            <div class="free-resource-item-child">
              <a href="https://courses.sportys.com/training/portal/course/PRIVATE/testprep/categories"
                 target="_blank" class="text-decoration-none text-dark">
                <div class="free-resource-blue-rectangle p-2">
                  <div class="test-preparation-body">
                    <div class="">
                      <app-icon glyph name="faa-three-rectangles"></app-icon>
                    </div>
                    <div class="mt-3">
                      <span class="test-preparation-title text-truncate-4">FREE STUDY DEMO</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="btn btn-primary btn-round study-btn px-3 text-size-12 py-2">
                      Study Now
                    </button>
                  </div>
                </div>
              </a>
            </div>
            <div class="free-resource-item-child">
              <div class="p-2 cursor-pointer"
                   [class.free-resource-blue-rectangle]="isLearnToFlyCoursePaid()"
                   [class.free-resource-gray-rectangle]="!isLearnToFlyCoursePaid()"
                   (click)="goToTestPrep()"
              >
                <div class="test-preparation-body">
                  <div class="">
                    <app-icon glyph name="faa-three-rectangles"></app-icon>
                  </div>
                  <div class="mt-3">
                                        <span class="test-preparation-title text-truncate-4">CUSTOM STUDY
                                            SESSIONS</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="btn btn-round px-2 text-size-12"
                          [class.disabled-study-btn]="!isLearnToFlyCoursePaid()"
                          [class.btn-primary]="isLearnToFlyCoursePaid()"
                          [class.study-btn]="isLearnToFlyCoursePaid()"
                          [class.px-3]="isLearnToFlyCoursePaid()"
                          [class.py-2]="isLearnToFlyCoursePaid()"
                  >
                    Study <span class="d-none d-lg-block pl-1">Now</span>
                    <app-icon *ngIf="!isLearnToFlyCoursePaid()" glyph name="lock-black"></app-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="free-resource-item-child">
              <div class="p-2 cursor-pointer"
                   [class.free-resource-blue-rectangle]="isLearnToFlyCoursePaid()"
                   [class.free-resource-gray-rectangle]="!isLearnToFlyCoursePaid()"
                   (click)="goToTestPrep()"
              >
                <div class="test-preparation-body">
                  <div class="">
                    <app-icon glyph name="faa-three-rectangles"></app-icon>
                  </div>
                  <div class="mt-3">
                                        <span class="test-preparation-title text-truncate-4">SPORTY'S FAA PRACTICE
                                            TEST</span>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <button class="btn btn-round px-2 text-size-12"
                          [class.disabled-study-btn]="!isLearnToFlyCoursePaid()"
                          [class.btn-primary]="isLearnToFlyCoursePaid()"
                          [class.study-btn]="isLearnToFlyCoursePaid()"
                          [class.px-3]="isLearnToFlyCoursePaid()"
                          [class.py-2]="isLearnToFlyCoursePaid()"
                  >
                    Study <span class="d-none d-lg-block pl-1">Now</span>
                    <app-icon *ngIf="!isLearnToFlyCoursePaid()" glyph name="lock-black"></app-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-3">
            <span class="text-size-10">Custom Study and Practice Tests require a free account</span>
          </div>
        </div>
      </div>
    </div>


    <hr class="color-secondary-dark my-2 py-0 w-100">
    <div class="row pb-md-2 pb-0 pl-3 pl-md-4 pl-lg-0 mt-4">
      <div class="col pl-lg-2 ml-3 pl-0">
        <div class="text-dark text-size-20 font-weight-600">FREE VIDEOS IN THIS COURSE</div>
      </div>
    </div>
    <app-learn-free-courses [course]="course" [showScrollbar]="false" [videos]="videos" [volume]="volume"
                            [fitContent]="true"
                            [maxItemsPerRow]="4"
                            [isLearnToFlyCoursePaid]="isLearnToFlyCoursePaid()"></app-learn-free-courses>

    <div *ngIf="!isLearnToFlyCoursePaid()"
         class="header-background-min border-bottom-left-radius-modal border-top-left-radius-modal border-bottom-right-radius-modal border-top-right-radius-modal mb-4 pt-3">

      <div class="text-white d-none d-md-flex row float-right mr-5">
        <div class="text-size-22">325</div>
        <div class="text-size-14 ml-2 d-flex align-items-start">Reviews</div>
      </div>
      <div class="d-lg-flex justify-content-between w-100">
        <div class="col ml-md-5 text-white mt-3">
          <div class="row d-flex justify-content-md-start justify-content-center w-100">
            <span class="text-size-20 font-weight-light font-weight-400">Start Training Now</span>
          </div>
          <div class="row pt-3 justify-content-md-start justify-content-center">
            <span class="text-size-32 mt-1 d-flex">LEARN TO FLY COURSE</span>
          </div>
          <div class="row pt-2 justify-content-md-start justify-content-center">
            <span class="text-size-32 mt-1 d-flex">{{ course?.price }}</span>
          </div>
          <div class="row mt-4 col col-md-9 px-0">
                        <span class="d-none d-md-block text-size-18 font-weight-light mt-1 mt-md-4 font-weight-400">Ace
                            your FAA written
                            test,
                            save money during flight training, and become
                            a better pilot with Sporty's Learn To Fly Course.</span>
            <span
              class="d-block d-md-none text-size-16 font-weight-light text-center mt-1 mt-md-4 font-weight-400">Ace
                            your
                            FAA
                            written test, save money during flight training, and become
                            a better pilot with Sporty's Learn To Fly Course.</span>
          </div>
          <div class="row pb-5 mt-3 mt-md-4 d-flex justify-content-md-start justify-content-center">
            <a href="https://www.sportys.com/learn-to-fly-course-private-pilot-test-prep-online-app-and-tv.html#reviews"
               target="_blank" class="btn border-white btn-round cursor-pointer py-2 text-white">
              Reviews
            </a>
            @if (course?.inCoursePurchaseEnabled) {
              <a class="btn btn-locked btn-round ml-3 px-5" (click)="onBuyClick($event)">Purchase Course</a>
            } @else {
              <a
                href="https://www.sportys.com/learn-to-fly-course-private-pilot-test-prep-online-app-and-tv.html?utm_source=onlinecoursedemo&utm_medium=referral&utm_campaign=LTFportalbutton"
                target="_blank" class="btn btn-locked btn-round ml-3 px-5">Purchase Course</a>
            }
          </div>
        </div>


        <div class="d-flex col-md col-lg-5 offset-lg-1 col-12 align-items-end">
          <div class="plate plate-white px-4 mb-md-5 mb-3 pt-3">
            <div class="row d-flex justify-content-start align-items-center w-100 pb-2 pl-1">
              <app-icon glyph name="blue-star"></app-icon>
              <app-icon glyph name="blue-star" class="ml-2"></app-icon>
              <app-icon glyph name="blue-star" class="ml-2"></app-icon>
              <app-icon glyph name="blue-star" class="ml-2"></app-icon>
              <app-icon glyph name="blue-star" class="ml-2"></app-icon>
            </div>
            <div class="row d-flex justify-content-md-start justify-content-center w-100 pl-1">
                            <span class="text-size-20 mt-1">Score a 98% on my PPL studying the material
                                in this course
                                alone.</span>
            </div>
            <div class="row d-flex justify-content-between align-items-center mt-4 w-100 pl-1">
              <span class="text-size-16">Ryan P.</span>
              <div class="verified-purchaser px-2 py-1" disabled>Verified Purchaser</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <hr class="color-secondary-dark my-0 py-0 w-100">
    <div class="row pb-md-2 pb-md-0 pb-2 pl-3 pl-md-4 pl-lg-0 mt-3">
      <div class="col pl-lg-2 ml-3 pl-0">
        <div class="text-dark text-size-20 font-weight-600">OTHER POPULAR COURSES</div>
      </div>
    </div>

    <app-discover-courses [showScrollbar]="false" [courses]="popularCourses" [user]="user">
    </app-discover-courses>

    <hr class="d-md-none d-flex color-secondary-dark my-0 py-0 w-100">
  </div>


  <div class="d-md-none d-flex body-content">
    <div
      class="plate plate-white px-2 pt-3 pb-3 border-bottom-left-radius-modal border-bottom-right-radius-modal border-top-left-radius-modal border-top-right-radius-modal h-100 my-3">
      <div class="d-flex justify-content-center align-items-center plate-header px-4">
                <span class="text-size-22 ml-2 text-center">What type of pilot do you want to
                    become?</span>
      </div>
      <div class="d-flex justify-content-center mt-1 mb-3">
                <span class="text-size-14 mt-2 text-center">Take this 1 minute self assessment quiz to
                    help find the best course path
                    for you.</span>
      </div>
      <div class="d-flex justify-content-center w-100">
        <div class="row d-flex justify-content-center w-100">
          <div class="btn btn-primary btn-round mt-2 mt-md-4 py-2" (click)="openStartAssessmentModal()">
            Start Assessment
            <app-icon glyph name="rounded-tick" class="ml-2"></app-icon>
          </div>
        </div>
      </div>
    </div>

  </div>

  <app-pilot-training-plus></app-pilot-training-plus>

</div>
